import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
export default function PaginationNumbers({ pages, page, setPage }) {
    return (_jsx(Box, Object.assign({ sx: {
            paddingY: 4,
        } }, { children: _jsx(Pagination, { count: pages, page: page, onChange: (event, page) => setPage(page), siblingCount: 1, boundaryCount: 1 }) })));
}
